module.exports = __webpack_public_path__ + "static/media/muteIcon.6edf8059.svg";